import React, { useState } from "react";

import "./Navbar.css";

import { FaBars, FaTimes } from "react-icons/fa";
// import "../src/Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MdLogout } from "react-icons/md";
import { logIn } from "../../Redux/Action";
import { FaStepBackward } from "react-icons/fa";
const MenuNavbar = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  const dispatch = useDispatch();
  function logOut() {
    dispatch(logIn([]));
    navigate("/");
  }
  const state = useSelector((state) => state?.changeTheState);
  // //console.log(state);
  // //console.log(state.user.userName);
  const handleCategory = (category) => {
    setSelectedCategory((prevCategory) =>
      prevCategory === category ? null : category
    );
  };
  return (
    <nav className="centernav sticky top-0 z-[1000] bg-white">
      <div className="navbar-container">
        <nav className="navbar block ">
          <div className="block ">
            <div className="fabar" onClick={toggleMenu}>
              {isMenuOpen ? <FaTimes /> : <FaBars />}
              {/* <FaBars /> */}
            </div>
          </div>
          <ul className={`nav-menu ${isMenuOpen ? "open" : ""}`}>
            <div className="hover-dropdown uppercase">
              <li onClick={() => navigate("/BookingReference")}>
                Booking Reference
              </li>{" "}
              <li onClick={() => navigate("/InternalTransfer")}>
                INTERNAL TRANSFER
              </li>
              <li onClick={() => navigate("/SafariPlanning")}>
                Safari Planning
              </li>
              <li onClick={() => navigate("/FuelVoucher")}>Fuel Voucher</li>
              <li onClick={() => navigate("/VehicleMovement")}>
                Vehicle Movement
              </li>
              <li onClick={() => navigate("/DriverAllocation")}>
                Driver Allocation
              </li>
            </div>
          </ul>
        </nav>
        <div className="flex justify-between items-center w-[80%]">
          <aside className="welcom__nav">
            <h1 className="font-bold text-lg text-white ">Welcome to TecH23</h1>
          </aside>
          <aside>
            {/* <h1 className="font-bold ml-1 md:text-lg text-white uppercase">
              Welcome : {state?.user?.userCode ? state?.user.userCode : " "}
            </h1> */}
          </aside>
        </div>
        <aside>
          <button
            onClick={() => {
              navigate("/SafariDashboard");
            }}
            className="button__logout__navbar"
          >
            {" "}
            DASHBOARD
          </button>
        </aside>

        <div className="logout__fullscren">
          <button
            onClick={() => {
              navigate("/SafariDashboard");
            }}
            className="log__out__icon"
          >
            {" "}
            <FaStepBackward />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default MenuNavbar;
